import React, { useState, useEffect, useCallback } from "react";
import { MemberHeader } from "./MemberHeader";
import { useDispatch, useSelector } from "react-redux";
import MembersTable from "./MembersTable";
import {
  memberActionCreator,
  memberDataActionCreater,
  memberDataVisibiltyActionCreater,
  selectedMemberRows,
} from "../../Redux/Members/actionCreator";
import axios from "axios";
import { openSnackbar } from "./../../Redux/Snackbar/snackbarStore";
import { MultiSelectDropdown } from "../../Components/SelectDropdown/MultiSelectDropdown";
import { BASE_URL } from "./../../Components/URL/Url";
import {
  loaderStartActionCreater,
  loaderEndActionCreater,
} from "./../../Redux/Loader/LoaderActionCreator";
import { LogoutSayasActionCreate } from "../../Redux/Authontication/authonticationActionCreator";
import { getPricePerShareActionCreater } from "../../Redux/Dashboard/dashboardActionCreator";
import CustomSearch from "../../Components/CustomSearch/CustomSearch";
import useFilter from "../../hooks/useFilter";

const MembersHome = (props) => {
  const { setMemberDataLength, memberDataLength, setId } = props;
  const [finalData, setFinalData] = useState(null);
  const [finalAdvanceSearchData, setFinalAdvanceSearchData] = useState(null);
  const [conflict, setConflict] = useState(false);
  const selectedMembers = useSelector((state) => state.members.selectedRow);
  const dispatch = useDispatch();
  const tableRef = React.createRef();
  const [isAction, setIsAction] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  // Search and filter state
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    member: "",
    mobileSignUpStatus: "",
    activityStatus: "",
  });

  // Advanced search dropdown values state
  const [advancedSearchFilters, setAdvancedSearchFilters] = useState({
    state: "",
    district: "",
    taluka: "",
    city: "",
    organisation_name: "",
    member: "",
    shareholder: "",
    mobileStatus: "",
    activity: "",
    pincode: "",
  });

  // Range search values state
  const [rangeSearchFilters, setRangeSearchFilters] = useState({
    totalShare: [0, 0],
    shareCapital: [0, 0],
    shareApplicationMoney: [0, 0],
  });

  const [option_users, setOption_users] = useState([
    "All Members",
    "Nominal Members",
    "Regular Members",
    "Mobile App Enabled",
    "Active Members",
    "Inactive Members",
    "Mobile App Disabled",
  ]);
  const [option_action_1, setOption_action_1] = useState([
    "Import Members",
    "Export Members",
    "Import Share Application",
    "Share Transfer",
  ]);
  const [option_action_2, setOption_action_2] = useState([
    "Activate Member",
    "Enable Mobile App",
    "Disable Mobile App",
    "Update Member Type",
    "Issue Shares",
    "Deactivate Member",
  ]);

  const [sayasAcc, setSayasAcc] = useState({});

  const dashboardData = useSelector((state) => {
    return state.sayasAccount;
  });

  const getAuthData = useSelector((state) => {
    return state.auth.loginToken;
  });

  useEffect(() => {
    setSayasAcc(dashboardData);
  }, [dashboardData]);

  useEffect(() => {
    dispatch(getPricePerShareActionCreater(sayasAcc?.pricePerShare));
  }, [sayasAcc]);

  const [userRole, serUserRole] = useState("");
  const userRoleFetch = useSelector((state) => {
    return state.auth.role;
  });
  
  useEffect(() => {
    serUserRole(userRoleFetch);
  }, [userRoleFetch]);

  useEffect(() => {
    if (userRole !== "") {
      if (userRole.toLowerCase() === "staff") {
        setOption_action_1([]);
        setOption_action_2([]);
      }
    }
  }, [userRole]);

  const [optionVal, setOptionVal] = useState("All Members");

  const [filterParams, setFilterParams] = useState({
    page: 1,
    limit: 10,
    search: "",
    member: "",
    mobileSignUpStatus: "",
    activityStatus: "",
  });
  
  let token = getAuthData;
  const {data: membersData, loading: membersLoading, error: membersError, refetch} = useFilter(`${BASE_URL}/api/v1/member/v2`, filterParams, token);

  // Handle page change
  const handlePageChange = (page, pageSize) => {
    // console.log("📄 Page change requested:", { 
    //   page, 
    //   pageSize, 
    //   currentPage, 
    //   currentFilterLimit: filterParams.limit,
    //   totalPages 
    // });
    
    // Validate page bounds
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    
    // Use current page size if not provided
    const finalPageSize = pageSize || filterParams.limit || 10;
    
    // Update filterParams only - this will trigger the API call
    setFilterParams(prev => {
      // Create new filter params with the updated page
      const newParams = {
        ...prev,
        page: page,
        limit: finalPageSize // Always include the current limit
      };
      
      // console.log("📄 Filter params comparison:", {
      //   previous: { page: prev.page, limit: prev.limit },
      //   new: { page: newParams.page, limit: newParams.limit }
      // });
      
      // Only update if something has actually changed
      if (prev.page === newParams.page && prev.limit === newParams.limit) {
        console.log("📄 No changes in pagination params, skipping update");
        return prev;
      }
      
      // console.log("📄 Updating filter params for page change:", newParams);
      return newParams;
    });
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    // console.log("📏 Page size change requested:", { newPageSize, currentPageSize: filterParams.limit });
    
    // Update filterParams only - reset to page 1 when changing page size
    setFilterParams(prev => {
      // Only update if the page size has actually changed
      if (prev.limit === newPageSize) {
        console.log("📏 Page size hasn't changed, skipping update");
        return prev;
      }
      
      const newParams = {
        ...prev,
        limit: newPageSize,
        page: 1 // Reset to first page when changing page size
      };
      
      // console.log("📏 Updating filter params for page size change:", newParams);
      return newParams;
    });
  };

  // Search function using custom hook
  const searchMembers = (searchValue) => {
    console.log("🔍 searchMembers called with:", searchValue);
    
    // Update search term immediately for UI responsiveness
    setSearchTerm(searchValue);
    
    // Reset to first page when searching and update in one call
    const newFilterParams = {
      ...filterParams,
      search: searchValue || "",
      page: 1
    };
    
    console.log("📋 Updating filterParams:", newFilterParams);
    setFilterParams(newFilterParams);
    
    if (searchValue && searchValue.trim() !== "") {
      dispatch(openSnackbar(`Searching for "${searchValue}"...`, "info"));
    }
  };

  // Clear search
  const clearSearch = () => {
    setSearchTerm("");
    setFilterParams(prev => ({
      ...prev,
      search: "",
      page: 1
    }));
  };

  // Handle advanced search dropdown changes (without triggering API)
  const handleAdvancedSearchChange = (filterType, values) => {
    // console.log("🔽 Advanced search change:", filterType, values);
    
    // Convert array to comma-separated string for API
    const stringValue = Array.isArray(values) ? values.join(',') : values;
    
    setAdvancedSearchFilters(prev => ({
      ...prev,
      [filterType]: stringValue
    }));
  };

  // Handle range search changes (without triggering API)
  const handleRangeSearchChange = (filterType, range) => {
    console.log("📊 Range search change:", filterType, range);
    setRangeSearchFilters(prev => ({
      ...prev,
      [filterType]: range
    }));
  };

  // Trigger advanced search with all collected filter values
  const triggerAdvancedSearch = () => {
    // console.log("🔍 Triggering advanced search with filters:", {
    //   advancedSearchFilters,
    //   rangeSearchFilters
    // });

    // Start with base filter params
    const newFilterParams = {
      page: 1,
      limit: filterParams.limit || 10,
      search: filterParams.search || "",
      member: filterParams.member || "",
      mobileSignUpStatus: filterParams.mobileSignUpStatus || "",
      activityStatus: filterParams.activityStatus || "",
    };

    // console.log("📋 Base filter params:", newFilterParams);

    // Add dropdown filter values (convert arrays to strings)
    Object.entries(advancedSearchFilters).forEach(([key, value]) => {
      if (value && value !== "") {
        if (Array.isArray(value) && value.length > 0) {
          // If it's an array, join with comma
          newFilterParams[key] = value.join(',');
          console.log(`📝 Added dropdown filter ${key}:`, value.join(','));
        } else if (typeof value === 'string' && value.trim() !== '') {
          // If it's a string, use as is
          newFilterParams[key] = value;
          console.log(`📝 Added dropdown filter ${key}:`, value);
        }
      }
    });

    // Add range filter values (only if meaningful)
    Object.entries(rangeSearchFilters).forEach(([key, value]) => {
      if (value && Array.isArray(value) && value.length === 2) {
        // Only add if both values are meaningful (not both zero)
        if (value[0] > 0 || value[1] > 0) {
          newFilterParams[key] = value;
          console.log(`📊 Added range filter ${key}:`, value);
        }
      }
    });

    // console.log("📋 Complete filter params to send:", newFilterParams);
    setFilterParams(newFilterParams);
    
    dispatch(openSnackbar("Advanced search applied!", "info"));
  };

  // Clear all advanced search filters
  const clearAdvancedSearch = () => {
    setAdvancedSearchFilters({
      state: "",
      district: "",
      taluka: "",
      city: "",
      organisation_name: "",
      member: "",
      shareholder: "",
      mobileStatus: "",
      activity: "",
      pincode: "",
    });
    
    setRangeSearchFilters({
      totalShare: [0, 0],
      shareCapital: [0, 0],
      shareApplicationMoney: [0, 0],
    });
    
    // Reset to base filter params
    setFilterParams(prev => ({
      ...prev,
      page: 1,
      // Remove all advanced search params
      state: "",
      district: "",
      taluka: "",
      city: "",
      organisation_name: "",
      shareholder: "",
      mobileStatus: "",
      activity: "",
      pincode: "",
      totalShare: "",
      shareCapital: "",
      shareApplicationMoney: "",
    }));
    
    dispatch(openSnackbar("Advanced search cleared!", "info"));
  };

  const handleActivateStatus = async (status, selectedUsers, setOptions) => {
    console.log("🔍 Selected users for status update:", selectedUsers);
    
    // Extract member IDs - use _id field
    let memberArray = [];
    if (selectedUsers && selectedUsers.length > 0) {
      memberArray = selectedUsers.map((user) => {
        // Use _id field for member identification
        const memberId = user._id;
        console.log("🔍 User object:", user, "Extracted _id:", memberId);
        return memberId;
      }).filter(id => id != null && id !== undefined && id !== ''); // Filter out null/undefined/empty values
    }
    
    console.log("📋 Final member array for API:", memberArray);
    
    if (memberArray.length === 0) {
      dispatch(openSnackbar("No valid members selected!", "error"));
      return;
    }
    
    if (status === "Activate Member") {
      const memberData = { memberIds: memberArray, activityStatus: true };
      console.log("🚀 Sending activate request:", memberData);
      try {
        let token = getAuthData;
        if (!token) {
          dispatch(LogoutSayasActionCreate());
        }
        await axios.post(BASE_URL + `/api/v1/member/updateStatus`, memberData, {
          headers: {
            Authorization: `Bearer ` + `${token}`,
          },
        });
        refetch(); // Use refetch from custom hook
        dispatch(openSnackbar("Member Activated Successfully!", "success"));
      } catch (err) {
        let errors = err?.response?.data?.error;
        if (errors) dispatch(openSnackbar(errors, "error"));
        if (err?.request?.status === 401) {
          dispatch(LogoutSayasActionCreate());
        }
      }
    } else if (status === "Deactivate Member") {
      const memberData = { memberIds: memberArray, activityStatus: false };
      console.log("🚀 Sending deactivate request:", memberData);
      try {
        let token = getAuthData;
        if (!token) {
          dispatch(LogoutSayasActionCreate());
        }
        await axios.post(BASE_URL + `/api/v1/member/updateStatus`, memberData, {
          headers: {
            Authorization: `Bearer ` + `${token}`,
          },
        });
        refetch(); // Use refetch from custom hook
        dispatch(openSnackbar("Member Deactivated Successfully!", "success"));
      } catch (err) {
        let errors = err?.response?.data?.error;
        if (errors) dispatch(openSnackbar(errors, "error"));
        if (err?.request?.status === 401) {
          dispatch(LogoutSayasActionCreate());
        }
      }
    } else if (status === "Enable Mobile App") {
      const memberData = { memberIds: memberArray, mobileSignUpStatus: true };
      console.log("🚀 Sending enable mobile request:", memberData);
      try {
        let token = getAuthData;
        if (!token) {
          dispatch(LogoutSayasActionCreate());
        }
        await axios.post(
          BASE_URL + `/api/v1/member/updateMobileStatus`,
          memberData,
          {
            headers: {
              Authorization: `Bearer ` + `${token}`,
            },
          }
        );
        refetch(); // Use refetch from custom hook
        dispatch(openSnackbar("Mobile App Enabled Successfully!", "success"));
      } catch (err) {
        let errors = err?.response?.data?.error;
        if (errors) dispatch(openSnackbar(errors, "error"));
        if (err.request.status === 401) {
          dispatch(LogoutSayasActionCreate());
        }
      }
    } else if (status === "Disable Mobile App") {
      const memberData = { memberIds: memberArray, mobileSignUpStatus: false };
      console.log("🚀 Sending disable mobile request:", memberData);
      try {
        let token = getAuthData;
        if (!token) {
          dispatch(LogoutSayasActionCreate());
        }
        await axios.post(
          BASE_URL + `/api/v1/member/updateMobileStatus`,
          memberData,
          {
            headers: {
              Authorization: `Bearer ` + `${token}`,
            },
          }
        );
        refetch(); // Use refetch from custom hook
        dispatch(openSnackbar("Mobile App Disabled Successfully!", "success"));
      } catch (err) {
        let errors = err?.response?.data?.error;
        if (errors) dispatch(openSnackbar(errors, "error"));
        if (err?.request?.status === 401) {
          dispatch(LogoutSayasActionCreate());
        }
      }
    }
    setOptions(option_action_1);
    dispatch(memberActionCreator([]));
    setIsAction(true);
  };

  const filterUsers = (name) => {
    // Guard clause to prevent running if the filter hasn't changed
    if (name === optionVal) {
      console.log(`Filter is already set to "${name}". Skipping.`);
      return;
    }

    // console.log("🔄 Switching filter to:", name);
    // console.log("🔄 Current advancedSearchFilters before clear:", advancedSearchFilters);
    
    setOptionVal(name);
    
    // Clear search when switching filters
    setSearchTerm("");
    
    // Force clear advanced search filters when switching member types
    const clearedAdvancedFilters = {
      state: "",
      district: "",
      taluka: "",
      city: "",
      organisation_name: "",
      member: "",
      shareholder: "",
      mobileStatus: "",
      activity: "",
      pincode: "",
    };
    
    const clearedRangeFilters = {
      totalShare: [0, 0],
      shareCapital: [0, 0],
      shareApplicationMoney: [0, 0],
    };
    
    // console.log("🧹 Setting cleared filters:", clearedAdvancedFilters);
    setAdvancedSearchFilters(clearedAdvancedFilters);
    setRangeSearchFilters(clearedRangeFilters);
    
    // Build completely new filter params (don't merge with existing)
    const newFilterParams = {
      page: 1,
      limit: filterParams.limit || 10, // Keep current page size
      search: "",
        member: "",
        mobileSignUpStatus: "",
        activityStatus: "",
      };
    
    if (name === "All Members") {
      // Reset all filters
      dispatch(openSnackbar("Showing all members", "info"));
    } else if (name === "Active Members") {
      newFilterParams.activityStatus = "true";
      dispatch(openSnackbar("Active Members Filtered Successfully!", "success"));
    } else if (name === "Inactive Members") {
      newFilterParams.activityStatus = "false";
      dispatch(openSnackbar("Inactive Members Filtered Successfully!", "success"));
    } else if (name === "Mobile App Enabled") {
      newFilterParams.mobileSignUpStatus = "true";
      dispatch(openSnackbar("Mobile App Enabled Members Filtered Successfully!", "success"));
    } else if (name === "Mobile App Disabled") {
      newFilterParams.mobileSignUpStatus = "false";
      dispatch(openSnackbar("Mobile App Disabled Members Filtered Successfully!", "success"));
    } else if (name === "Nominal Members") {
      newFilterParams.member = "Nominal";
      dispatch(openSnackbar("Nominal Members Filtered Successfully!", "success"));
    } else if (name === "Regular Members") {
      newFilterParams.member = "Regular";
      dispatch(openSnackbar("Regular Members Filtered Successfully!", "success"));
    }
    
    // Update filters state for consistency
    setFilters({
      member: newFilterParams.member,
      mobileSignUpStatus: newFilterParams.mobileSignUpStatus,
      activityStatus: newFilterParams.activityStatus,
      search: newFilterParams.search,
    });
    
    // console.log("🎯 Final filter params to send:", newFilterParams);
    // Remove setTimeout and setCurrentPage to prevent interference with pagination
    setFilterParams(newFilterParams);
    
    // console.log("🎯 Filter switched to:", name);
  };

  // Handle conflict and refetch
  useEffect(() => {
    if (getAuthData && conflict) {
      setConflict(false);
      refetch();
      setIsAction(false);
    }
  }, [conflict, getAuthData, refetch]);

  useEffect(() => {
    if (finalData && selectedMembers?.length) {
      let myData = finalData ? [...finalData] : [];

      let selectedEl = selectedMembers[selectedMembers?.length - 1];
      let index = myData.findIndex((el) => el.memberId === selectedEl.memberId);

      let topEl = myData.splice(index, 1);
      myData.unshift(topEl[0]);
      setFinalData([...myData]);
    }
  }, [selectedMembers]);

  const groupFilter = (target, search) => {
    return target !== null
      ? search
          .split(",")
          .filter((t) => t.trim() !== "")
          .some((t) =>
            typeof target === "string"
              ? target.toLowerCase().indexOf(t.trim().toLowerCase()) > -1
              : target.toString().indexOf(t.trim()) === 0
          )
      : false;
  };

  const initialColumnStatus = {
    memberId: false,
    member: false,
    firstName: true,
    middleName: false,
    lastName: true,
    email: false,
    phone: true,
    nominee_name: false,
    organisation_name: false,
    state: true,
    city: true,
    district: true,
    taluka: true,
    pincode: true,
    addressLine_1: false,
    addressLine_2: false,
    role: false,
    team: false,
    date: false,
    totalShare: true,
    shareApplicationMoney: true,
    activityStatus: false,
    mobileSignUpStatus: false,
  };

  const columns = [
    {
      title: "Member ID",
      field: "memberId",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.memberId, term),
      customSort: (a, b) => {
        return (a.memberId || "").localeCompare(b.memberId || "");
      },
    },
    {
      title: "Member",
      field: "member",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.member, term),
      customSort: (a, b) => {
        return (a.member || "").localeCompare(b.member || "");
      },
    },
    {
      title: "First Name",
      field: "firstName",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.firstName, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.firstName || "").localeCompare(b.firstName || "");
      },
    },
    {
      title: "Middle Name",
      field: "middleName",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.middleName, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.middleName || "").localeCompare(b.middleName || "");
      },
    },
    {
      title: "Last Name",
      field: "lastName",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.lastName, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.lastName || "").localeCompare(b.lastName || "");
      },
    },
    {
      title: "Email",
      field: "email",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.email, term),
      customSort: (a, b) => {
        return (a.email || "").localeCompare(b.email || "");
      },
    },
    {
      title: "Phone",
      field: "phone",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.phone, term),
    },
    {
      title: "Nominee Name",
      field: "nominee_name",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.nominee_name, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.nominee_name || "").localeCompare(b.nominee_name || "");
      },
    },
    {
      title: "Organisation Name",
      field: "organisation_name",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.organisation_name, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.organisation_name || "").localeCompare(
          b.organisation_name || ""
        );
      },
    },
    {
      title: "State",
      field: "state",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.state, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.state || "").localeCompare(b.state || "");
      },
    },
    {
      title: "District",
      field: "district",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.district, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.district || "").localeCompare(b.district || "");
      },
    },
    {
      title: "Taluka",
      field: "taluka",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.taluka, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.taluka || "").localeCompare(b.taluka || "");
      },
    },
    {
      title: "City",
      field: "city",
      customFilterAndSearch: (term, rowData) => groupFilter(rowData.city, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customSort: (a, b) => {
        return (a.city || "").localeCompare(b.city || "");
      },
    },
    {
      title: "Share Capital",
      field: "shareCapital",
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.shareCapital, term),
      headerStyle: {
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Total Shares",
      field: "totalShare",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.totalShare, term),
    },
    {
      title: "Share Application Money",
      field: "shareApplicationMoney",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.shareApplicationMoney, term),
    },
    {
      title: "% Shareholding",
      field: "totalShare",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      render: (rowData) =>
        `${
          sayasAcc?.totalShares
            ? ((rowData?.totalShare / sayasAcc?.totalShares) * 100).toFixed(5)
            : 0
        }%`,
      customFilterAndSearch: (term, rowData) =>
        groupFilter(
          `${((rowData?.totalShare / sayasAcc?.totalShares) * 100).toFixed(
            5
          )}%`,
          term
        ),
    },
    {
      title: "Pin Code",
      field: "pincode",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.pincode, term),
    },
    {
      title: "Address Line 1",
      field: "addressLine_1",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.addressLine_1, term),
      customSort: (a, b) => {
        return (a.addressLine_1 || "").localeCompare(b.addressLine_1 || "");
      },
    },
    {
      title: "Address Line 2",
      field: "addressLine_2",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.addressLine_2, term),
      customSort: (a, b) => {
        return (a.addressLine_2 || "").localeCompare(b.addressLine_2 || "");
      },
    },
    {
      title: "Activity Status",
      field: "activity",
    },
    {
      title: "Mobile App",
      field: "mobileStatus",
      headerStyle: {
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Share Holder",
      field: "shareholder",
      headerStyle: {
        whiteSpace: "nowrap",
      },
      customFilterAndSearch: (term, rowData) =>
        groupFilter(rowData.shareholder, term),
      customSort: (a, b) => {
        return (a.shareholder || "").localeCompare(b.shareholder || "");
      },
    },
  ];

  const columnsStatus = useSelector((state) => {
    return state.members.columnsStatus;
  });

  const setColumnsStatus = (data) => {
    dispatch(memberDataVisibiltyActionCreater(data));
  };

  useEffect(() => {
    dispatch(selectedMemberRows(undefined, []));
  }, []);

  // Handle the data from custom hook
  useEffect(() => {
    if (membersData && membersData.data) {
      const mappedData = membersData.data.map((ele) => {
        return {
          ...ele,
          shareCapital: ele.shareCapital > 0 ? ele.shareCapital : "0",
          totalShare: ele.totalShare > 0 ? ele.totalShare : "0",
          shareApplicationMoney:
            ele.shareApplicationMoney > 0 ? ele.shareApplicationMoney : "0",
          activity: ele.activityStatus === true ? "Active" : "Inactive",
          mobileStatus:
            ele.mobileSignUpStatus === true ? "Enabled" : "Disabled",
        };
      });

      setFinalData(mappedData);
      setFinalAdvanceSearchData(mappedData);
      
      // Update pagination state from API response
      const pagination = membersData.pagination;
      
      // console.log("📊 Updating state from API response:", {
      //   currentPage: pagination.currentPage,
      //   totalPages: pagination.totalPages,
      //   totalItems: pagination.totalItems
      // });
      
      // Only update these if they've actually changed
      if (currentPage !== pagination.currentPage) {
        setCurrentPage(pagination.currentPage);
      }
      if (pageSize !== pagination.itemsPerPage) {
        setPageSize(pagination.itemsPerPage);
      }
      if (totalItems !== pagination.totalItems) {
        setTotalItems(pagination.totalItems);
      }
      if (totalPages !== pagination.totalPages) {
        setTotalPages(pagination.totalPages);
      }
      if (memberDataLength !== pagination.totalItems) {
        setMemberDataLength(pagination.totalItems);
      }
    }
  }, [membersData]);

  // Handle loading state
  useEffect(() => {
    if (membersLoading) {
      dispatch(loaderStartActionCreater());
    } else {
      dispatch(loaderEndActionCreater());
    }
  }, [membersLoading, dispatch]);

  // Handle error state
  useEffect(() => {
    if (membersError) {
      console.error("Error fetching members:", membersError);
      if (membersError.includes('401')) {
        dispatch(LogoutSayasActionCreate());
      }
      dispatch(openSnackbar(membersError, "error"));
    }
  }, [membersError, dispatch]);

  return (
    <>
      <MemberHeader
        tableRef={tableRef}
        option_users={option_users}
        option_action_1={option_action_1}
        option_action_2={option_action_2}
        setConflict={setConflict}
        handleActivateStatus={handleActivateStatus}
        filterUsers={filterUsers}
        optionVal={optionVal}
        setData={() => {}} // No longer needed
        data={null} // No longer needed
        finalData={finalData}
        memberDataLength={memberDataLength}
        columns={columns}
        columnsStatus={columnsStatus}
        setIsAction={setIsAction}
      />

      <div>
        <div
          className="d-flex justify-content-end gap-2 align-items-center mb-3"
          style={{ padding: "0rem 2rem" }}
        >
       
          <CustomSearch
            data={finalData || []}
            ref={tableRef}
            setOptionVal={setOptionVal}
            tableData={finalData}
            setTableData={setFinalData}
            finalAdvanceSearchData={finalAdvanceSearchData}
            setFinalAdvanceSearchData={setFinalAdvanceSearchData}
            rangeSearchCol={[
              ["Total Shares", "totalShare"],
              ["Share Capital", "shareCapital"],
              ["Share Application Money", "shareApplicationMoney"],
            ]}
            simpleSearchCol={[
              ["State", "state"],
              ["District", "district"],
              ["Taluka", "taluka"],
              ["City", "city"],
              ["Organisation Name", "organisation_name"],
              ["Member Type", "member"],
              ["Share Holder", "shareholder"],
              ["Mobile App", "mobileStatus"],
              ["Activity Status", "activity"],
              ["Pin Code", "pincode"],
            ]}
            columns={columns}
            isAction={isAction}
            setIsAction={setIsAction}
            optionVal={optionVal}
            searchMembers={searchMembers}
            isSearching={searchTerm !== ""}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            clearSearch={clearSearch}
            // Advanced search props
            advancedSearchFilters={advancedSearchFilters}
            setAdvancedSearchFilters={setAdvancedSearchFilters}
            rangeSearchFilters={rangeSearchFilters}
            setRangeSearchFilters={setRangeSearchFilters}
            handleAdvancedSearchChange={handleAdvancedSearchChange}
            handleRangeSearchChange={handleRangeSearchChange}
            triggerAdvancedSearch={triggerAdvancedSearch}
            clearAdvancedSearch={clearAdvancedSearch}
          />
          <MultiSelectDropdown
            columns={columns}
            columnsStatus={columnsStatus}
            setColumnsStatus={setColumnsStatus}
          />
        </div>
        <MembersTable
          tableRef={tableRef}
          data={finalData || []}
          setMemberDataLength={setMemberDataLength}
          columns={columns}
          columnsStatus={columnsStatus}
          setId={setId}
          currentPage={currentPage}
          pageSize={pageSize}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          isServerSidePagination={true}
        />
      </div>
    </>
  );
};

export default MembersHome;
